import { Directive, HostListener, ElementRef } from '@angular/core';
 
@Directive({
  selector: '[appCamelcase]'
})
export class CamelcaseDirective {
 
  constructor(private el: ElementRef) { }
 
  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputValue = this.el.nativeElement.value;
    const camelCaseValue = inputValue.replace(/\b\w/g, firstChar => firstChar.toUpperCase());
    this.el.nativeElement.value = camelCaseValue;
  }
 
}